// activityNewUser7
export default {
  routerTitle: '盈宝迎新盛惠',
  shareTitle: '迎新盛惠 盈宝新人奖金直冲6000+HKD',
  shareDesc: '财富升级！千元礼包等你拿！',

  cardOneLabel1: '注册就送 HK$ 88 礼包',
  cardOneValue11: '内地客户送30天港股LV2行情券',
  cardOneValue12: '完成美股非专业订户问卷送30天美股LV1行情',
  cardOneDesc1: '注：香港及海外地区送港股LV1行情',
  cardOneLabel2: '开户就送 HK$ 2256 礼包',
  cardOneValue21: '30天港股LV2串流报价行情',
  cardOneValue22: '完成美股非专业订户问卷送30天美股LV1行情',
  cardOneDesc2: '注：香港及海外地区港股送30天LV1行情，美股送30天美股LV1行情',

  cardTwoTitle: '首次入金2万 (或等值) 以上',
  cardTwoSubTitle: '首次入金 HK$ 20,000 - 299,999(或等值)',
  cardTwoDesc: '满足条件一次性发放8张100待生效代金券',
  // --
  cardTwoTable1Label1: '30天内无出金记录；',
  cardTwoTable1Label2: '且30天内成交股票≥1次',
  cardTwoTable1Desc1: '满足条件后，4张代金券生效可使用；',
  cardTwoTable1Desc2: '生效后60天内有效。',
  // --
  cardTwoTable2Label1: '60天内无出金记录；',
  cardTwoTable2Label2: '且30天内成交股票≥1次',
  cardTwoTable2Desc1: '满足条件后，2张代金券生效可使用；',
  cardTwoTable2Desc2: '生效后60天内有效。',
  // --
  cardTwoTable3Label1: '90天内无出金记录；',
  cardTwoTable3Label2: '且30天内成交股票≥1次',
  cardTwoTable3Desc1: '满足条件后，2张代金券生效可使用；',
  cardTwoTable3Desc2: '生效后60天内有效。',
  cardTwoTips: '特别说明：成交股票指成交港股或美股，不包含申购货币基金、新股、日内融及投资组合产品。',

  cardThreeTitle: '首次入金30万 (或等值) 以上',
  cardThreeSubTitle: '首次入金 HK$ 300,000 (或等值)',
  cardThreeDesc: '满足首次入金条件一次性发放8张100待生效代金券',
  // --
  cardThreeTable1Label1: '30天内无出金记录；',
  cardThreeTable1Label2: '且30天内成交股票≥1次',
  cardThreeTable1Desc1: '满足条件后，8张代金券生效可使用；',
  cardThreeTable1Desc2: '生效后60天内有效。',
  // --
  cardThreeTable2Label1: '30天内无出金记录；',
  cardThreeTable2Label2: '且交易额达<span>100万</span><i>(或等值)</i>',
  cardThreeTable2Desc1: '满足交易额条件后，发放7张代金券，即时生效可使用；',
  cardThreeTable2Desc2: '生效后60天内有效。',
  // --
  cardThreeTable3Label1: '60天内无出金记录；',
  cardThreeTable3Label2: '且交易额达<span>200万</span><i>(或等值)</i>',
  cardThreeTable3Desc1: '满足交易额条件后，发放7张代金券，即时生效可使用；',
  cardThreeTable3Desc2: '生效后60天内有效。',
  // --
  cardThreeTable4Label1: '90天内无出金记录；',
  cardThreeTable4Label2: '且交易额达<span>300万</span><i>(或等值)</i>',
  cardThreeTable4Desc1: '满足交易额条件后，发放7张代金券，即时生效可使用；',
  cardThreeTable4Desc2: '生效后60天内有效。',
  cardThreeTips: '注：首笔入金2万奖励和首笔入金30万奖励只能参与一个。',

  award: '奖',
  moneyCoupon: '代金券',
  awardTotal: '共获得',
  cashCoupons: '现金券',
  giftPack: '礼包',
  highestGift: '最高赠送'
}
